import { render } from "./RoomPlayers.vue?vue&type=template&id=42e9fe3f"
import script from "./RoomPlayers.vue?vue&type=script&lang=js"
export * from "./RoomPlayers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__